import React, { useState, useRef, useEffect, useContext } from "react";
import Swal from "sweetalert2";
import close from "../../assets/images/findclose.png";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import { useDbContext } from "../../context/DbContext";
function AdminVerification({ onClose, onVerified }) {
  const [actualPassword, setactualPassword] = useState("");
  const [enteredPassword, setEnteredPassword] = useState("");
 const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const { dbCode } = useDbContext();

  const { agentCode } = useContext(AuthContext);
  

  const agentCodeRef = useRef(agentCode);

  useEffect(() => {
    agentCodeRef.current = agentCode;
  }, [agentCode]);

  const [userType, setuserType] = useState("");

  useEffect(() => {
    const storeduType = sessionStorage.getItem("userType");
    if (storeduType) {
      setuserType(storeduType);
    }
  }, []);
  const verifyPassword = async () => {
    try {
      const response = await axios.post(`${apiBaseUrl}/common/verifypassword/${dbCode}`, {
        agentCode: agentCode,
        password: enteredPassword,
      });
////////console.log("Response from password verification:", response.data.success);

      if (response.data.success) {
        onVerified(true);
        onClose();
      } else {
        alert("Incorrect password");
        onVerified(false);
      }
    } catch (error) {
      console.error("Password verification error:", error);
      alert("Error", "Something went wrong while verifying password");
      onVerified(false);
    }
  };

  return (
    <div className="absolute lg:w-[30vw]  lg:h-[15vh]    rounded-[10px] bg-[#f8f9f9] border border-[#4a4a4a] flex items-center justify-center gap-[1vw] mt-3">
      <input
        type="text"
        value={enteredPassword}
        onChange={(e) => setEnteredPassword(e.target.value)}
        placeholder="Enter Password"
        className="h-[3vh] w-[60%] px-2 border border-gray-400 rounded"
      />
      <button
        onClick={()=>verifyPassword()}
        className="h-[4vh] w-[20%] rounded-[5px] bg-[rgba(0,8,180,0.73)] text-white text-center font-nunito text-[16px]  border-none"
      >
        Submit
      </button>
      <div
        onClick={onClose}
        className="absolute top-1 right-1 w-5 h-5 cursor-pointer"
      >
        <img src={close} alt="Close" className="w-full h-full" />
      </div>
    </div>
  );
}

export default AdminVerification;